import * as types from './mutation-types'

const mutations = {
  [types.SET_LOADING](state, loading) {
    state.loading = loading
  },
  [types.SET_LOGINPOP](state, loginPop) {
    state.loginPop = loginPop
  },
  [types.SET_USER](state, user) {
    state.user = user
  },
  [types.SET_EID](state, eid) {
      state.eid = eid
  },
  [types.SET_PAGE] (state, page) {
      state.page = page
  },
  [types.SET_CLIENTTYPE](state, ClientType) {
    state.ClientType = ClientType
  },
  [types.SET_ERRORMSG](state, errorMsg) {
    state.errorMsg = errorMsg
  },
  [types.SET_NODATATIP](state, noDataTip) {
    state.noDataTip = noDataTip
  },
  [types.SET_REFRESH](state, refresh) {
    state.refresh = refresh
  },
  [types.SET_ISINIT](state, isInit) {
    state.isInit = isInit
  },
  [types.SET_AAENROLLMENT] (state, aaEnrollment) {
    state.aaEnrollment = aaEnrollment
  },
  [types.SET_INITAAENROLLMENT](state, initAaEnrollment) {
    state.initAaEnrollment = initAaEnrollment
  },
  [types.SET_INITAAENROLLMENTLIST](state, aaEnrollmentList) {
    state.aaEnrollmentList = aaEnrollmentList
  },
  [types.SET_NOWIDENTITY](state, nowIdentity) {
    state.nowIdentity = nowIdentity
  },
  [types.SET_CHANNELID](state, channelid) {
    state.channelid = channelid
  },
  [types.SET_SHOWAPPTIPS](state, showAppTips) {
    state.showAppTips = showAppTips
  },
  [types.SET_SPECIALTOPICBUYDIALOGVISIBLE](state, specialTopicBuyDialogVisible) {
    state.specialTopicBuyDialogVisible = specialTopicBuyDialogVisible
  }
}

export default mutations
